export class UserModel {
  _id?: string | undefined;
  name?: string = "";
  surname?: string = "";
  password?: string = "";
  email?: string = "";
  roles?: string = "";
  enabled?: boolean = false;
}
